//import libraries
import { Component, OnInit, AfterViewInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppPermissions } from '../../../constants/app-permission';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { AuthService } from '../../../services/auth.service';
import { GeneralService } from '../../../services/general.service';
import { ProfileService } from '../../../services/profile.service';
import { ConfirmationDialogService } from '../../general/modals/confirmation/confirmation.service';


//import classes
import {
  UserMangActionAddEditIn, UserMangActionAddEditOut, UserMangActionUpdateOut, SubUserList
} from '../../../classes/profile.model';

//import validators
import { ValidateExtension } from '../../../validators/extension.validator';
import { ValidateUniqueEmail } from '../../../validators/uniqueEmail.validator';

declare var $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, AfterViewInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  //common data
  data: any;

  //tab 1
  generalForm: FormGroup;
  generalFormApproved: Boolean = false;
  generalFormSubmitted: Boolean = false;
  generalFormMsg: any;
  generalLang: any;
  generalData: any;
  businessSizeValues;

  //tab2
  userForm: FormGroup;
  userFormSubmitted: Boolean = false;
  userFormMsg: any;
  userLang: any;
  userData: SubUserList[];
  sub_user_id: any;

  dtOptions1: any;
  dtCols1: any;
  show_delete1: any;

  constructor(
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private generalService: GeneralService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private validateUniqueEmail: ValidateUniqueEmail,
    private confirmationDialogService: ConfirmationDialogService
  ) { }

  ngOnInit() {

    //fetch data
    this.data = this.route.snapshot.data['data'];

    //tab1 actions
    this.tab1Actions();

    //tab2 actions
    this.tab2Actions();

    //load scripts
    this.scriptActions();

  }

  ngAfterViewInit(): void {

    let tab = this.route.snapshot.paramMap.get('tab');

    if (tab)
      $('.nav-tabs a[href="#settingsTab"]').tab('show');

  }

  tab1Actions(): void {

    // console.log(this.data);

    //load languages
    this.generalLang = this.profileService.GeneralGetLangData(this.data);
    this.generalLangAssign();

    //load tab1 data
    this.generalData = this.profileService.GeneralGetServData(this.data);

    //load form datas
    this.generalFormInit();

  }

  generalLangAssign(): void {

    this.businessSizeValues = [
      { value: 0, text: this.generalLang.profile.businessSize1 },
      { value: 1, text: this.generalLang.profile.businessSize2 },
      { value: 2, text: this.generalLang.profile.businessSize3 },
      { value: 3, text: this.generalLang.profile.businessSize4 },
    ];

    this.generalFormMsg = {
      'fname': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'lname': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'phone': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'company': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'vat': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'hqo': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'size': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'profile': [{ type: 'validExt', message: 'File format is not supported' }]
    }

  }

  generalFormInit(): void {

    this.generalForm = this.formBuilder.group({
      email: [this.generalData.email],
      fname: [this.generalData.fname, [Validators.required]],
      lname: [this.generalData.lname, [Validators.required]],
      password: [''],
      phone: [this.generalData.phone, [Validators.required]],
      company: [this.generalData.company, [Validators.required]],
      vat: [this.generalData.vat, [Validators.required]],
      hqo: [this.generalData.hqo, [Validators.required]],
      size: [(this.generalData.size != '') ? +this.generalData.size : null, [Validators.required]],
      profile: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]],
      profileImg: [''],
      id: [this.generalData.id],
    });

    this.generalForm.disable();
  }

  generalFormEdit(): void {
    this.generalFormApproved = true;
    this.generalForm.enable();
    this.generalForm.controls.email.disable();
  }

  generalFormProfileChange(event) {

    this.fileChange(event, this.generalForm, 'profile', 'profileImg');

  }

  generalFormSubmit(): void {

    this.generalFormSubmitted = true;

    if (this.generalForm.invalid)
      return;

    this.profileService.GeneralPostData(this.generalForm.value)
      .subscribe(
        (res) => {

          if (res.token)
            this.authService.update_user_key(res.token);

          this.generalService.notify_msg('success', res.msg);

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => { this.router.navigate([AppFrontRoutes.PROFILE]); });
        },
        (err) => {
          this.router.navigateByUrl(AppFrontRoutes.DASHBOARD, { skipLocationChange: true })
            .then(() => { this.router.navigate([AppFrontRoutes.PROFILE]); });
        }
      );

  }

  tab2Actions(): void {

    //load language data
    this.userLang = this.profileService.UserLangData(this.data);

    //load tab2 data
    this.userData = this.profileService.UserServData(this.data);

    this.userFormMsg = {
      'user_email': [
        { type: 'required', message: this.generalLang.general.requiredField },
        { type: 'email', message: 'Enter valid email ID' },
        { type: 'emailTaken', message: 'Email already exists' },
      ],
      'user_fname': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'user_lname': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'user_password': [{ type: 'required', message: this.generalLang.general.requiredField }],
      'user_profile': [{ type: 'validExt', message: 'File format is not supported' }]
    }

    //load form datas
    this.userFormInit();

    //load datatable
    this.datatable_load();

  }

  userFormInit(): void {

    this.sub_user_id = '';

    this.userForm = this.formBuilder.group({
      user_email: ['', [Validators.required, Validators.email]],
      user_fname: ['', [Validators.required]],
      user_lname: ['', [Validators.required]],
      user_password: ['', [Validators.required]],
      user_profile: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]],
      user_profileImg: [''],
      user_profileImgDisp: [''],
      user_deadline: ['2', [Validators.required]],
      user_servicing: ['2', [Validators.required]],
      user_human_res: ['2', [Validators.required]],
      user_meas_tools: ['2', [Validators.required]],
      user_problem_solv: ['2', [Validators.required]],
      user_doc_mang: ['2', [Validators.required]],
      user_customers: ['2', [Validators.required]],
      user_consultancy: ['2', [Validators.required]],
      user_academy: ['2', [Validators.required]],
      user_project: ['2', [Validators.required]],
      user_audit: ['2', [Validators.required]],
      sub_user_id: [''],
      action: ['update'],
    });

  }

  userFormUpdateData(res: UserMangActionAddEditOut): void {

    this.sub_user_id = res.details.sub_user_id.toString();
    this.userForm.controls['user_email'].setAsyncValidators(this.validateUniqueEmail.createValidator(this.sub_user_id));

    this.userForm.patchValue({
      user_email: res.details.user_email,
      user_fname: res.details.user_fname,
      user_lname: res.details.user_lname,
      user_profileImgDisp: res.details.user_profile,
      user_deadline: res.details.user_deadline ? res.details.user_deadline.toString() : 0,
      user_servicing: res.details.user_servicing ? res.details.user_servicing.toString() : 0,
      user_human_res: res.details.user_human_res ? res.details.user_human_res.toString() : 0,
      user_meas_tools: res.details.user_meas_tools ? res.details.user_meas_tools.toString() : 0,
      user_problem_solv: res.details.user_problem_solv ? res.details.user_problem_solv.toString() : 0,
      user_doc_mang: res.details.user_doc_mang ? res.details.user_doc_mang.toString() : 0,
      user_customers: res.details.user_customers ? res.details.user_customers.toString() : 0,
      user_consultancy: res.details.user_consultancy ? res.details.user_consultancy.toString() : 0,
      user_academy: res.details.user_academy ? res.details.user_academy.toString() : 0,
      user_project: res.details.user_project ? res.details.user_project.toString() : 0,
      user_audit: res.details.user_audit ? res.details.user_audit.toString() : 0,
      sub_user_id: this.sub_user_id,
    });

    //clear password required field if it is edit form
    if (this.userForm.controls.sub_user_id.value) {
      this.userForm.get('user_password').clearValidators();
      this.userForm.get('user_password').updateValueAndValidity();
    }



  }

  userMangAction(event): void {
    var target = event.currentTarget;

    var table1_name = '#user_table';
    var table1 = new $.fn.dataTable.Api(table1_name);
    var selected = table1.rows({ selected: true }).ids().toArray();

    let action = target.dataset.action;
    let id;

    if (action == 'multiDelete')
      id = selected;
    else
      id = target.dataset.id;

    let input: UserMangActionAddEditIn = { action: action, sub_user_id: id };

    if (input.action == 'delete' || input.action == 'multiDelete') {

      this.confirmationDialogService.confirm(this.userLang.general.confirmTitle, this.userLang.general.confirmText)
        .subscribe(
          (confirmed) => {
            if (!confirmed)
              return;
            this.userMangActionCall(input);
          });
    }
    else
      this.userMangActionCall(input);

  }

  userMangActionCall(input): void {

    this.profileService.UserMangActionAddEdit(input)
      .subscribe(
        (res: UserMangActionAddEditOut) => {
          if (res.status) {
            if (input.action == 'delete' || input.action == 'multiDelete') {
              this.generalService.notify_msg('success', res.msg);
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.PROFILE, { tab: 2 }]);
                });
            }
            else {
              this.userFormUpdateData(res);
              document.getElementById("userModalBtn").click();
            }
          }
          else
            this.generalService.notify_msg('error', res.msg);
        }
      );


  }

  userFormProfileChange(event) {

    this.fileChange(event, this.userForm, 'user_profile', 'user_profileImg');

  }

  userFormSubmit(): void {

    this.userFormSubmitted = true;

    if (this.userForm.invalid)
      return;

    this.profileService.UserMangActionUpdate(this.userForm.value)
      .subscribe(
        (res: UserMangActionUpdateOut) => {

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
            $('.splash').modal('hide');

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.PROFILE, { tab: 2 }]);
              });
          }
          else
            this.generalService.notify_msg('error', res.msg);
        }
      );
  }

  datatable_load() {

    this.dtCols1 = [
      { id: 2, value: this.userLang.user.sNo, isSelected: false },
      { id: 4, value: this.userLang.user.email, isSelected: false },
      { id: 5, value: this.userLang.user.firstName, isSelected: false },
      { id: 6, value: this.userLang.user.lastName, isSelected: false },
    ];

    var table1_name = '#user_table';

    this.dtOptions1 = {
      paging: false,
      columnDefs: [
        {
          targets: 0,
          visible: false,
          orderable: false,
        },
        {
          targets: 1,
          orderable: false,
          className: 'select-checkbox'
        },
      ],
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      bSortClasses: false,
      rowReorder: { selector: 'td:nth-child(2)' },
      bAutoWidth: false,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api(table1_name);
          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var table1 = new $.fn.dataTable.Api(table1_name);
        var self = this;

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api(table1_name);
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.show_delete1 = false;
            else
              self.show_delete1 = true;
          });

        //drag and drop action
        table1.on('row-reordered', function () {
          self.store_order1();
        });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.userLang.general.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api(table1_name);
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod Servicing"
            },
            {
              extend: 'pdfHtml5',
              text: this.userLang.general.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api(table1_name);
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod Servicing"
            },
            {
              extend: 'excel',
              text: this.userLang.general.exportExc,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api(table1_name);
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod Servicing"
            },
            {
              extend: 'print',
              text: this.userLang.general.print,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api(table1_name);
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod Servicing"
            },
          ], select: true
        }).container().appendTo($('#userExportModalAct'));

      }
    };

  }

  catch_sort1(): void {
    this.store_order1();
  }

  store_order1(): void {

    setTimeout(() => {

      var table1_name = '#user_table';
      var table1 = new $.fn.dataTable.Api(table1_name);

      let all_ids = table1.rows().ids().toArray();
      let table = { 'table_name': 'admin_login', 'id': 'id', 'order': 'sort1' };
      let data = { action: 'sorting', id: all_ids, table: table };

      this.profileService.UserMangSortUpdate(data).subscribe();
    }, 500);
  }

  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.dtCols1.length; i++) {
      this.dtCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.dtCols1.length; i++) {
      if (this.dtCols1[i].id == id)
        this.dtCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#user_table';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.dtCols1.length; i++) {
      if (this.dtCols1[i].isSelected)
        table1.column(parseInt(this.dtCols1[i].id)).select();
      else
        table1.column(parseInt(this.dtCols1[i].id)).deselect();
    }

  }

  //sidebar scripts
  scriptActions(): void {

    setTimeout(function () {

      $('.filestyle').each(function () {
        var $this = $(this), options = {
          'input': $this.attr('data-input') !== 'false',
          'htmlIcon': $this.attr('data-icon'),
          'buttonBefore': $this.attr('data-buttonBefore') === 'true',
          'disabled': $this.attr('data-disabled') === 'true',
          'size': $this.attr('data-size'),
          'text': $this.attr('data-text'),
          'btnClass': $this.attr('data-btnClass'),
          'badge': $this.attr('data-badge') === 'true',
          'dragdrop': $this.attr('data-dragdrop') !== 'false',
          'badgeName': $this.attr('data-badgeName'),
          'placeholder': $this.attr('data-placeholder')
        };

        $this.filestyle(options);
      });

    }, 500);

    var options,
      target,
      $splashEl = $('.splash'),
      $body = $('body');

    $splashEl.on('show.bs.modal', function (e) {
      options = e.relatedTarget.dataset.options;
      target = $(e.target);

      target.addClass(options);
      $body.addClass(options).addClass('splash');
    });
    $splashEl.on('hidden.bs.modal', function () {
      target.removeClass(options);
      $body.removeClass(options).removeClass('splash');
    });


  }

  ErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  fileChange(event, form, source, target) {

    form.get(target).patchValue('');

    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (form.get(source).valid) {
          form.get(target).patchValue(reader.result);
        }
      };

    }
  }

}
